import React from 'react';
import { Card, Avatar, Badge, Col, Row } from 'antd';
import { UserOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { IUser } from '../../types/user';

interface ProfileProps {
  user: IUser;
}

export const Profile: React.FC<ProfileProps> = ({ user }) => {
  return (
    <Row gutter={[8, 8]} justify="center" style={{ width: '100%', margin: '8px 0 0 0' }}>
      <Col span={24} md={14}>
        <Card
          hoverable
          cover={
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '20px 0',
              }}>
              <Badge
                count={
                  user.isVerified ? <CheckCircleOutlined style={{ color: '#52c41a' }} /> : null
                }>
                <Avatar size={100} icon={<UserOutlined />} />
              </Badge>
            </div>
          }>
          <Card.Meta
            title={<div style={{ fontSize: '1.5em', fontWeight: 'bold' }}>{user.name}</div>}
            description={
              <>
                <div style={{ marginBottom: '10px', color: 'rgba(0, 0, 0, 0.65)' }}>
                  <strong>Email:</strong> {user.email}
                </div>
                <div style={{ marginBottom: '10px', color: 'rgba(0, 0, 0, 0.65)' }}>
                  <strong>Date of registration:</strong>{' '}
                  {new Date(+user.createdAt).toLocaleDateString()}
                </div>
              </>
            }
          />
        </Card>
      </Col>
    </Row>
  );
};
